import { render, staticRenderFns } from "./potentialOrder.vue?vue&type=template&id=d9ae348a"
import script from "./potentialOrder.vue?vue&type=script&lang=js"
export * from "./potentialOrder.vue?vue&type=script&lang=js"
import style0 from "./potentialOrder.vue?vue&type=style&index=0&id=d9ae348a&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports